/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ConnectZaloCreate = lazyLoad(
  () => import('./index'),
  module => module.ConnectZaloCreate
);
